import mixpanel from "mixpanel-browser";
import { Configuration } from "./config";

if (Configuration.mixpanel.enabled) {
  mixpanel.init(Configuration.mixpanel.token, {
    api_host: Configuration.mixpanel.apiHost,
  });
}
